import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { CancelBackgroundJobDialog } from '~src/backgroundJob/components/CancelBackgroundJobDialog';
import { IBackgroundJobInfo } from '~src/backgroundJob/types/BackgroundJobs';
import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { formatListAsString } from '~src/schedule/utils/ListToStringFormatter';
import { IExplorableItemTypeInfo } from '~src/spacesPlatform/models/resourceInfoParts';
import { selectContentFromAppState } from '~src/spacesPlatform/selectors/ContentSelectors';

import { OpenCancelFlowRunDialogAction } from '../actions/OpenCancelFlowRunDialogAction';
import { FlowOutputStepRunListItemInfo, isCancellableStatus } from '../models/FlowOutputStepRunInfo';

// Names the run's other pending or in-progress output steps; only loaded rows are checked.
export function cancelFlowRunDisclaimer(
  outputStepRun: FlowOutputStepRunListItemInfo,
  contentItems: ReadonlyArray<IExplorableItemTypeInfo | undefined>,
): string[] {
  const otherOutputStepNames = contentItems
    .filter((item): item is FlowOutputStepRunListItemInfo => !!item && item.contentType === 'flowOutputStepRun')
    .filter((run) => run.flowRunId === outputStepRun.flowRunId && run.id !== outputStepRun.id && isCancellableStatus(run.status))
    .map((run) => Messages.backgroundJobCancelDialogFlowOutputStepName({ OUTPUT_STEP_NAME: run.outputName }));
  if (otherOutputStepNames.length === 0) {
    return [];
  }
  return [Messages.backgroundJobCancelDialogFlowSameJob({
    OUTPUT_STEP_NAME: outputStepRun.outputName,
    OTHER_OUTPUT_STEP_COUNT: otherOutputStepNames.length,
    OTHER_OUTPUT_STEP_NAMES: formatListAsString(otherOutputStepNames),
  })];
}

export function* openCancelFlowRunDialog(action: OpenCancelFlowRunDialogAction): SagaIterator {
  try {
    const contentItems: ReadonlyArray<IExplorableItemTypeInfo> = yield select(selectContentFromAppState);
    const backgroundJob = { id: action.outputStepRun.backgroundJobId, taskType: 'Flow' } as IBackgroundJobInfo;
    yield call(CancelBackgroundJobDialog.open, backgroundJob, cancelFlowRunDisclaimer(action.outputStepRun, contentItems));
  } catch (e) {
    yield put(requestFailed(e, Messages.backgroundJobCancelFailed()));
  }
}
